// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism-tomorrow.css"

// HubSpot tracking code
export const onRouteUpdate = ({ location, prevLocation }) => {
  // for SPA page traking
  if (window._hsq && prevLocation !== null) {
    // setTimeoutを使用して非同期にHubSpotのトラッキングを呼び出す
    // これにより、React Helmetによるdocument.titleの更新を待つことができる
    setTimeout(() => {
      window._hsq.push(["setPath", location.pathname]);
      window._hsq.push(["trackPageView"]);
    }, 100); // setTimeoutの遅延時間・ミリ秒
  }
};